import { SyncOutlined } from "@ant-design/icons";
import { Tag } from "antd";

export const ConfirmadoTag = ({ icon, text = null, ...restProps }) => {
  return (
    <Tag color="processing" {...restProps}>
      {icon ? icon : <SyncOutlined spin />}{" "}
      {text === null ? "Confirmado" : text}
    </Tag>
  );
};
